// extracted by mini-css-extract-plugin
export default {"splitter":"splitPane_splitter__5g8s8","horizontal":"splitPane_horizontal__zvhZa","vertical":"splitPane_vertical__eIyTo"};